import {useEffect, useState} from "react";
import { Sun, MoonStar } from 'lucide-react'
import { motion } from "framer-motion";

export default function ThemeChanger(){
    const [theme, setTheme] = useState(() => localStorage.getItem("theme") || "light");
    
    useEffect(()=>{
        localStorage.setItem("theme", theme);
        document.documentElement.setAttribute("data-theme", theme);
    },[theme])
    
    return(
        <motion.div
            onClick={() => setTheme(theme === "light" ? "dark" : "light")}
            className="cursor-pointer"
        >
            {theme === "light" ? (
                <motion.div
                    key="sun"
                    initial={{ opacity: 0}}
                    animate={{ opacity: 1}}
                    exit={{ opacity: 0}}
                    transition={{ duration: 0.5, ease: "easeInOut" }}
                >
                    <Sun  />
                </motion.div>
            ) : (
                <motion.div
                    key="moon"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.5, ease: "easeInOut" }}
                >
                    <MoonStar />
                </motion.div>
            )}
        </motion.div>
    )
}